import { ElementId, NO_INDEX } from '@tikka/basic-types';
import { Intervals } from '@tikka/intervals/intervals';
import { MutationActions } from '../../db/mutation-actions';
import { AudioMarkerWriteDto } from '../../chaat/chaat-types';

// [<AbstractClass>]
export abstract class AudioMarkerActions {
  getTargetMarker(): AudioMarkerWriteDto {
    const audioPos = this.currentAudioPosition;
    const markerHitIntervals = this.currentAudioMarkerHitIntervals;
    const targetMarkerIndex = markerHitIntervals.containing(audioPos);
    if (targetMarkerIndex !== NO_INDEX) {
      return this.currentAudioMarkers[targetMarkerIndex];
    } else {
      return null;
    }
  }

  addUpdate(data: AudioMarkerWriteDto): void {
    this.mutationActions.addUpdateChaatAudioMarker(data);
  }

  remove(id: ElementId): void {
    this.mutationActions.removeChaatAudioMarker(id);
  }

  addUpdateFromAudioPosition() {
    const existingMarker = this.getTargetMarker();
    if (!existingMarker) {
      this.addUpdate({ id: null, time: this.currentAudioPosition });
    } else {
    }
  }

  removeFromAudioPosition() {
    const targetMarker = this.getTargetMarker();
    if (targetMarker) {
      // TODO alert when not in a marker hit region?
      this.remove(targetMarker.id);
    } else {
    }
  }

  abstract get mutationActions(): MutationActions;
  abstract get currentAudioPosition(): number;
  abstract get currentAudioMarkers(): any[]; // TODO typing
  abstract get currentAudioMarkerHitIntervals(): Intervals;
}
